// Google Ads / Analytics event tracking helper.
// Safely calls window.gtag if the tag is loaded (see public/index.html).
// All calls are no-ops if gtag isn't available.
// Events are sent to ALL configured gtag IDs (Google Ads + GA4) since
// we don't pass `send_to` - gtag.js broadcasts to every config() by default.

const safeGtag = (...args) => {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  try {
    window.gtag(...args);
  } catch (e) {
    // Never let analytics break the app
  }
};

/**
 * Track a generic event. Broadcast to every configured gtag ID
 * (Google Ads AW-... and GA4 G-...).
 */
export const trackEvent = (name, params = {}) => {
  safeGtag('event', name, params);
};

/** Convenience wrappers for the CTAs used across the site. */
export const trackBooking = (location) =>
  trackEvent('booking_click', { event_category: 'CTA', event_label: location });

export const trackWhatsApp = (location, extra = {}) =>
  trackEvent('whatsapp_click', { event_category: 'CTA', event_label: location, ...extra });

export const trackInstagram = (location, extra = {}) =>
  trackEvent('instagram_click', { event_category: 'Social', event_label: location, ...extra });

export const trackNav = (target) =>
  trackEvent('nav_click', { event_category: 'Navigation', event_label: target });

export const trackSocial = (network) =>
  trackEvent('social_click', { event_category: 'Social', event_label: network });

export const trackMaps = () =>
  trackEvent('maps_click', { event_category: 'Location', event_label: 'google_maps' });
